// extracted by mini-css-extract-plugin
export default {"academyGif":"CTABanner_academyGif__FsCwl"};